import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import loadConfig from "../../../../Services/Api/ApiServices";
import {
  GetAC_FindOutAwardById,
  GetAC_findOutAwardNames,
  UpdateAC_findOutAward,
} from "../../../../Redux/Reducers/Submitter/FindOutAward";
import { decryptToken } from "../../../../Services/Encryption/EncryptionParams";
import SharedDiv from "../../../../Components/SharedDiv/SharedDiv";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";

function FindOutAwardPage(props) {
  const { AppGuid } = useParams();
  const dispatch = useDispatch();
  const [jsonFile, setJsonFile] = useState(null);
  
  const { FindOutAward, FindOutAwardNamesList, loadingFindOutAward } = useSelector(
    (state) => ({
      FindOutAward: state.FindOutAward.FindOutAward,
      FindOutAwardNamesList: state.FindOutAward.FindOutAwardNamesList,
      loadingFindOutAward: state.FindOutAward.loadingFindOutAward,
    })
  );
  
  const [findOutList, setFindOutList] = useState({});

  // Load configuration data
  useEffect(() => {
    const fetchConfig = async () => {
      const jsonData = await loadConfig();
      setJsonFile(jsonData);
    };
    
    fetchConfig();
  }, []);

  // Fetch award data and names
  useEffect(() => {
    const applicationId = localStorage.getItem("ApplicationInformationId") || 
    props.applicationGuid
      
    if (applicationId) {
      dispatch(GetAC_findOutAwardNames());
      dispatch(GetAC_FindOutAwardById(applicationId));
    }
  }, [dispatch, AppGuid]);

  // Update local state when data is loaded
  useEffect(() => {
    if (loadingFindOutAward && FindOutAward) {
      setFindOutList({ ...FindOutAward });
    }
  }, [loadingFindOutAward, FindOutAward]);

  // Handle dropdown change and update data
  const handleFindOutChange = (e) => {
    const newValue = e.target.value;
    
    setFindOutList({
      ...findOutList,
      sU_NT_APP_findOutAwardNamesId: newValue,
    });
    
    dispatch(UpdateAC_findOutAward({
      sU_NT_APP_findOutAwardId: FindOutAward?.sU_NT_APP_findOutAwardId,
      sU_NT_APP_findOutAwardNamesId: newValue,
      applicationInformationId: FindOutAward?.applicationInformationId,
    }));
  };

  // Don't render until data is loaded
  if (!jsonFile || !FindOutAward) {
    return null;
  }

  return (
    <SharedDiv
      showTitle={true}
      titleName="كيف تعرفت على صندوق البحث العلمي"
      child={[
        <div className="form-grid" key="find-out-award-form">
          <AllDropDownsAHSF
            fieldsName="findOutName"
            show={true}
            disabled={props.shouldDisableFields}
            onChange={handleFindOutChange}
            defaultValue={FindOutAward?.sU_NT_APP_findOutAwardNamesId}
            arrayOoptionList={FindOutAwardNamesList}
            KeyText="findOutName"
            KeyValue="sU_NT_APP_findOutAwardNamesId"
            dropdownType="normal"
            validationMessage="يرجى تعبئة هذا الحقل"
          />
        </div>,
      ]}
    />
  );
}

export default FindOutAwardPage;
